<template>
  <div>
    <user-add user-title="公司招聘" user-add-url="/user/recruitment/add"></user-add>
    <el-table :data="Cdata" class="item-table" height="80vh">
      <el-table-column label="ID"  prop="id" fixed="left" width="60"></el-table-column>
      <el-table-column label="招聘岗位" prop="post"></el-table-column>
      <el-table-column label="薪资" prop="salary" width="80"></el-table-column>
      <el-table-column label="岗位职责" >
        <template slot-scope="scope">
          <span class="description" :title="Cdata[scope.$index].duty">{{Cdata[scope.$index].duty}}</span>
        </template>
      </el-table-column>
      <el-table-column label="岗位要求" >
        <template slot-scope="scope">
          <span class="description" :title="Cdata[scope.$index].demand">{{Cdata[scope.$index].demand}}</span>
        </template>
      </el-table-column>
      <el-table-column label="岗位详情" >
        <template slot-scope="scope">
          <span class="description" :title="Cdata[scope.$index].postDetail">{{Cdata[scope.$index].postDetail}}</span>
        </template>
      </el-table-column>
      <el-table-column label="邮箱" prop="email"></el-table-column>
      <el-table-column label="联系方式" prop="phoneNumber"></el-table-column>
      <el-table-column label="创建时间" prop="createTime"></el-table-column>
      <el-table-column label="更新时间" prop="updateTime"></el-table-column>
      <el-table-column label="操作" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleLook(Cdata[scope.$index].id)">查看</el-button>
          <el-button type="text" size="small" @click="handleChange(Cdata[scope.$index].id)">修改</el-button>
          <el-button type="text" size="small" @click="handleDelete(Cdata[scope.$index].id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import UserAdd from "@/views/User/Common/UserAdd";
export default {
  name: "RecruitmentBase",
  components: {UserAdd},
  data(){
    return{
      Cdata:null,//当前表格展示数据
      Cpage:null,//当前获取数据总页数
      TypeId:0,
      TypeList:[
        {'code':1,'name':'典型案例'},
        {'code':2,'name':'新闻资讯'}
      ],
      PostData:{
        'pageNumber':0,
        'pageSize':20,
        'type':1,
        'smallType':null,
      }
    }
  },
  created() {
    this.GetData(this.PostData)
  },
  methods:{
    GetData(PageData){
      this.$axios.get('/api/job/getAll').then(res=>{
        this.Cdata=res.data.data
        // this.Cpage=res.data.data.pages
      })
    },
    handleCurrentChange(index){
      this.PostData.pageNumber=index;
      this.GetData(this.PostData)
    },
    TypeChange(index,code){
      this.TypeId=index;
      this.PostData.type=code
      this.GetData(this.PostData)
    },
    handleLook(id){
      this.$router.push('/user/recruitment/look'+id)
    },
    handleChange(id){
      this.$router.push('/user/recruitment/change'+id)
    },
    Delete(id){
      this.$axios.delete('/api/job/deleteById',{ params:{
        id: id
        }}).then(res=>{
        this.GetData(this.PostData)
      })
    },
    handleDelete(id){
      this.$confirm('确定删除该条信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.Delete(id)
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
  }
}
</script>

<style scoped>
.description{
  width: 360px;
  height: 50px;
  white-space: nowrap;
  overflow: hidden;

}
</style>